<template>
  <div class="home-content">
    <div class="home-gallery-wrapper">
      <div ref="swiper" class="swiper">
        <div class="swiper-wrapper">
          <div v-for="photo in $store.state.homePhotos" class="swiper-slide">
            <img :src="photo" @load="imagesLoaded++" />
          </div>
        </div>
      </div>

      <div v-show="!isDevice" class="home-gallery-navigation">
        <button type="button" class="navigation-button-prev"></button>
        <button type="button" class="navigation-button-next"></button>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import { Autoplay, FreeMode, Navigation } from 'swiper/modules';
import { devices } from '../imports/utils.js';

export default {
  data() {
    return {
      imagesLoaded: 0,
      isDevice: devices()
    };
  },
  methods: {
    initSwiper() {
      if (this.swiper) return; // avoid double init

      this.swiper = new Swiper(this.$refs.swiper, {
        modules: [Autoplay, FreeMode, Navigation],
        loop: true,
        centerInsufficientSlides: true,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 500,
        freeMode: {
          enabled: true,
          sticky: true,
          momentumBounce: false,
        },
        grabCursor: true,
        navigation: {
          prevEl: '.navigation-button-prev',
          nextEl: '.navigation-button-next',
        },
      });
    }
  },
  mounted() {
    const watchImagesLoaded = () => {
      if (this.imagesLoaded === this.$store.state.homePhotos.length && this.$root.loaderPercentage === 100) {
        setTimeout(() => {
          this.initSwiper();
          this.$store.dispatch("togglePageReady", true);
        }, this.$root.loaderCountDuration - 2000);

        window.cancelAnimationFrame(watchImagesLoaded);
      } else {
        this.$root.setLoaderPercentage(
          Math.round((this.imagesLoaded / this.$store.state.homePhotos.length) * 100)
        );

        window.requestAnimationFrame(watchImagesLoaded);
      }
    };

    window.requestAnimationFrame(watchImagesLoaded);
  },
};
</script>

<style lang="scss">
.home-page {
  .header {
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 300px;
      z-index: -1;
      pointer-events: none;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);
    }

    .logo-link {
      .logo {
        display: none;

        &.logo-white {
          display: block;
        }
      }
    }

    .btn-menu {
      span {
        background-color: #fff;
      }
    }
  }

  .header-menu {
    li {

      a,
      button {
        span {
          color: #fff;
          background-image: linear-gradient(to right, #fff 0, #fff 100%);
        }

        &:hover,
        &.router-link-active {
          span {
            background-image: linear-gradient(to right, #fff 0, #fff 100%);
            color: #fff;
            background-size: 100% 1px;
            opacity: 0.5;
          }
        }
      }
    }
  }

  .header-secondary-menu {
    li {

      a,
      button {
        span {
          color: #fff;
          background-image: linear-gradient(to right, #fff 0, #fff 100%);
        }

        &:hover,
        &.router-link-active {
          span {
            background-image: linear-gradient(to right, #fff 0, #fff 100%);
            color: #fff;
            background-size: 100% 1px;
            opacity: 0.5;
          }
        }
      }
    }
  }
}

.home-content {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  height: 100svh;
}

.home-gallery-wrapper {
  height: 100%;

  .swiper {
    height: 100%;
  }

  .swiper-slide {
    overflow: hidden;
    height: 100%;
    width: auto;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .home-gallery-navigation {
    z-index: 1;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: space-between;

    .navigation-button-prev,
    .navigation-button-next {
      position: absolute;
      top: 150px;
      bottom: 0;
      width: 50%;
    }

    .navigation-button-prev {
      left: 0;
      cursor: url(../../images/cursor_left.svg) 25 25, pointer;
    }

    .navigation-button-next {
      right: 0;
      cursor: url(../../images/cursor_right.svg) 25 25, pointer;
    }
  }
}
</style>